document.querySelectorAll('.content-switcher').forEach((root) => {
	const switches = [...root.querySelectorAll('.js-content-switch')];
	const blocks = [...root.querySelectorAll('.js-content-block')];

	switches.forEach((switchBtn) => {
		switchBtn.addEventListener('click', (e) => {
			e.preventDefault();

			const targetId = switchBtn.getAttribute('data-target');
			if (!targetId) {
				return;
			}

			switches.forEach((btn) => btn.classList.remove('active'));
			switchBtn.classList.add('active');

			blocks.forEach((block) => block.classList.remove('active'));

			const targetBlock = document.getElementById(targetId);
			if (targetBlock) {
				targetBlock.classList.add('active');
			}
		});
	});
});
